export const RETURNING_USER_WHO_ACCEPTED_COOKIE =
  'returning_user_who_accepted_cookie';
export const SERVICE_CONSENT_EVENT = 'SERVICE_CONSENT_EVENT';
export const COOKIE_CONSENT_EVENT = 'UC_CONSENT'; // UC_UI_VIEW_CHANGED
export const SERVICE_CONSENT_SEARCH_PARAM = 'consents';
export const CONSENT_VIEW_INITIALISED = 'UC_UI_INITIALIZED';
